


(() => {
  const root = document.querySelector('.yastime-p4s-landing');
  if (!root) return;
  const N8N_WEBHOOK_URL = root.dataset.webhook || '';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header border on scroll + mobile CTA visibility
  const header = root.querySelector('.site-header');
  const mobileCta = root.querySelector('#mobile-cta');
  const hero = root.querySelector('.hero');
  const finalSec = root.querySelector('#consulenza');
  let heroVisible = true, finalVisible = false;
  const syncCta = () => mobileCta.classList.toggle('show', !heroVisible && !finalVisible);
  new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; syncCta(); }, { threshold: 0.15 }).observe(hero);
  new IntersectionObserver(([e]) => { finalVisible = e.isIntersecting; syncCta(); }, { threshold: 0.1 }).observe(finalSec);
  addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 8), { passive: true });

  // Hero: the empty days fill up after the messages arrive (one orchestrated moment)
  const week = root.querySelector('#week');
  const bubbles = week.querySelectorAll('.bubble');
  const play = () => {
    if (reduce) { bubbles.forEach(b => b.classList.add('in')); week.classList.add('filled'); return; }
    setTimeout(() => bubbles[0].classList.add('in'), 700);
    setTimeout(() => bubbles[1].classList.add('in'), 1500);
    setTimeout(() => week.classList.add('filled'), 2000);
  };
  // Parte quando la scheda è visibile (su telefono è sotto il titolo)
  const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.5 });
  io.observe(week);

  // Services: accessible tabs
  const tabs = [...root.querySelectorAll('#tabs [role="tab"]')];
  const select = (tab, focus) => {
    tabs.forEach(t => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
    if (focus) tab.focus();
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => select(t));
    t.addEventListener('keydown', e => {
      const k = e.key;
      let n = null;
      if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
      if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      if (k === 'Home') n = 0;
      if (k === 'End') n = tabs.length - 1;
      if (n !== null) { e.preventDefault(); select(tabs[n], true); }
    });
  });

  // System showcase: tabs between views
  const vtabs = [...root.querySelectorAll('#views [role="tab"]')];
  const vselect = (tab, focus) => {
    vtabs.forEach(t => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
    if (focus) tab.focus();
  };
  vtabs.forEach((t, i) => {
    t.addEventListener('click', () => vselect(t));
    t.addEventListener('keydown', e => {
      let n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % vtabs.length;
      if (e.key === 'ArrowLeft') n = (i - 1 + vtabs.length) % vtabs.length;
      if (n !== null) { e.preventDefault(); vselect(vtabs[n], true); }
    });
  });

  // Lightbox for screenshots
  const lb = root.querySelector('#lightbox');
  const lbImg = lb.querySelector('img');
  const lbCap = lb.querySelector('p');
  let lastFocus = null;
  const openLb = img => {
    lastFocus = img;
    lbImg.src = img.currentSrc || img.src;
    lbImg.alt = img.alt;
    lbCap.textContent = img.alt;
    lb.hidden = false;
    requestAnimationFrame(() => lb.classList.add('open'));
    lb.querySelector('.lightbox-close').focus();
    document.body.style.overflow = 'hidden';
  };
  const closeLb = () => {
    lb.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { lb.hidden = true; }, reduce ? 0 : 250);
    if (lastFocus) lastFocus.focus();
  };
  root.querySelectorAll('.shot, .phone img, .panel-shot img').forEach(img => {
    img.tabIndex = 0;
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', 'Ingrandisci: ' + img.alt);
    img.addEventListener('click', () => openLb(img));
    img.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(img); } });
  });
  lb.addEventListener('click', e => { if (e.target === lb || e.target.closest('.lightbox-close')) closeLb(); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });

  // FAQ: one open at a time, with a height animation
  const items = [...root.querySelectorAll('.faq details')];
  items.forEach(d => {
    const summary = d.querySelector('summary');
    const answer = d.querySelector('.answer');
    summary.addEventListener('click', e => {
      if (reduce) { if (!d.open) items.forEach(o => o !== d && (o.open = false)); return; }
      e.preventDefault();
      if (d.open) {
        const h = answer.scrollHeight;
        answer.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'ease' }).onfinish = () => { d.open = false; };
      } else {
        items.forEach(o => o !== d && (o.open = false));
        d.open = true;
        const h = answer.scrollHeight;
        answer.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    });
  });

  // Booking form: validation + confirmation
  const form = root.querySelector('#lead-form');
  const done = root.querySelector('#form-done');
  const phoneOk = v => v.replace(/[\s.\-()]/g, '').replace(/^(\+39|0039)/, '').match(/^3\d{8,9}$/);
  const checks = {
    nome: el => el.value.trim().length >= 2,
    telefono: el => !!phoneOk(el.value),
    pizzeria: el => el.value.trim().length >= 2,
    citta: el => el.value.trim().length >= 2,
  };
  const validate = el => {
    const ok = checks[el.name](el);
    el.closest('.field').classList.toggle('invalid', !ok);
    el.setAttribute('aria-invalid', !ok);
    return ok;
  };
  Object.keys(checks).forEach(n => form.elements[n].addEventListener('blur', e => { if (e.target.value) validate(e.target); }));
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const bad = Object.keys(checks).map(n => form.elements[n]).filter(el => !validate(el));
    const privacy = form.elements.privacy;
    root.querySelector('#c-privacy').classList.toggle('invalid', !privacy.checked);
    if (bad.length) { bad[0].focus(); return; }
    if (!privacy.checked) { privacy.focus(); return; }

    const errorBox = root.querySelector('#form-error');
    const submitBtn = root.querySelector('#form-submit');
    errorBox.classList.remove('show');

    const raw = Object.fromEntries(new FormData(form));
    const data = {
      nome: raw.nome.trim(),
      telefono: raw.telefono.replace(/[\s.\-()]/g, ''),
      pizzeria: raw.pizzeria.trim(),
      citta: raw.citta.trim(),
      consegne: raw.consegne,
      serata_difficile: raw.serata,
      fascia_chiamata: form.elements.quando.selectedOptions[0].text,
      consenso_privacy: true,
      consenso_marketing: !!form.elements.marketing.checked,
      inviato_il: new Date().toISOString(),
      pagina: location.href,
      fonte: new URLSearchParams(location.search).get('fonte') || new URLSearchParams(location.search).get('utm_source') || '',
    };

    // Campo trappola compilato: è un bot, mostriamo la conferma senza inviare nulla
    if (raw.sito_web) { showDone(data, raw); return; }

    if (!N8N_WEBHOOK_URL) {
      errorBox.textContent = 'Il modulo non è ancora collegato: inserisci l\'URL del webhook n8n in N8N_WEBHOOK_URL.';
      errorBox.classList.add('show');
      console.warn('N8N_WEBHOOK_URL vuoto: dati non inviati', data);
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Invio in corso…';
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 15000);
    try {
      const res = await fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal: ctrl.signal,
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      showDone(data, raw);
    } catch (err) {
      console.error('Invio al webhook non riuscito:', err);
      errorBox.textContent = 'Non siamo riusciti a inviare la richiesta. Riprova tra poco, oppure scrivici su WhatsApp.';
      errorBox.classList.add('show');
    } finally {
      clearTimeout(timer);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Prenota la consulenza gratuita';
    }
  });

  function showDone(data, raw) {
    const first = data.nome.trim().split(/\s+/)[0];
    root.querySelector('#done-text').textContent = `Grazie ${first}: ti chiamiamo ${raw.quando} per parlare di ${data.pizzeria}. Intanto ti mandiamo una conferma su WhatsApp.`;
    form.style.display = 'none';
    done.classList.add('show');
    done.focus({ preventScroll: true });
    done.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
  }
})();
